export const READER_AVATAR_SLUGS = [
  'owl',
  'fox',
  'bear',
  'rabbit',
  'cat',
  'dog',
  'panda',
  'lion',
  'frog',
  'penguin',
] as const;

export type ReaderAvatarSlug = (typeof READER_AVATAR_SLUGS)[number];

export interface ReaderAvatarOption {
  slug: ReaderAvatarSlug;
  label: string;
  src: string;
}

export const DEFAULT_READER_AVATAR_SLUG: ReaderAvatarSlug = 'owl';

export const READER_AVATAR_OPTIONS: ReaderAvatarOption[] = [
  { slug: 'owl', label: 'Owl', src: '/avatars/owl.svg' },
  { slug: 'fox', label: 'Fox', src: '/avatars/fox.svg' },
  { slug: 'bear', label: 'Bear', src: '/avatars/bear.svg' },
  { slug: 'rabbit', label: 'Rabbit', src: '/avatars/rabbit.svg' },
  { slug: 'cat', label: 'Cat', src: '/avatars/cat.svg' },
  { slug: 'dog', label: 'Dog', src: '/avatars/dog.svg' },
  { slug: 'panda', label: 'Panda', src: '/avatars/panda.svg' },
  { slug: 'lion', label: 'Lion', src: '/avatars/lion.svg' },
  { slug: 'frog', label: 'Frog', src: '/avatars/frog.svg' },
  { slug: 'penguin', label: 'Penguin', src: '/avatars/penguin.svg' },
];

export function readerAvatarOptionForSlug(slug: string | null | undefined): ReaderAvatarOption {
  return READER_AVATAR_OPTIONS.find((option) => option.slug === slug) ?? READER_AVATAR_OPTIONS[0]!;
}
